import React from "react";

const JQuery_Fade = () => {
  return (
    <div>
      <h1>JQuery_Fade</h1>
      <p>Placeholder component for: "JQuery_Fade"</p>
    </div>
  );
};

export default JQuery_Fade;
